__turbopack_context__.v({
  "blockFullWidth": "styles-module__T4-TMW__blockFullWidth",
  "blockFullWidthPadded": "styles-module__T4-TMW__blockFullWidthPadded",
  "blockLarge": "styles-module__T4-TMW__blockLarge",
  "blockMedium": "styles-module__T4-TMW__blockMedium",
  "blockSmall": "styles-module__T4-TMW__blockSmall",
  "blockSmallExpandRight": "styles-module__T4-TMW__blockSmallExpandRight",
  "blockSmallMarginLeft": "styles-module__T4-TMW__blockSmallMarginLeft",
  "hoverableButton": "styles-module__T4-TMW__hoverableButton",
  "layout": "styles-module__T4-TMW__layout",
  "roundedButton": "styles-module__T4-TMW__roundedButton",
  "squareButton": "styles-module__T4-TMW__squareButton",
});
